export default "__VITE_ASSET__6uY6Y_kb__"